export default __webpack_public_path__ + "static/media/23.4070d7a8.jpg";